const ContactInfo = ({ icon: Icon, title, children }) => (
  <div className="flex items-start gap-3 sm:gap-4">
    <div className="w-12 h-12 my-5 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0">
      <Icon className="text-emerald-600" size={24} />
    </div>
    <div className="max-w-xl my-5">
      <p className="font-semibold text-gray-900 mb-1">{title}</p>
      <div className="text-gray-600 text-sm break-words">{children}</div>
    </div>
  </div>
);
export default ContactInfo;